import { privateRequest } from "../axios";

const ENDPOINTS = {
  MY_TEAM_WITH_GC_DETAIL: "api/CRM/MyTeamWithGCDetail",
  GET_MANAGERS: "api/Users/GetManagers",
  REPORT_BY_TEAM: "api/Expense/ReportByTeam",
};

const fetchTeamWithGCDetail = async (payload: any) => {
  const response = await privateRequest.post(
    ENDPOINTS.MY_TEAM_WITH_GC_DETAIL,
    payload,
  );
  return response.data;
};

const fetchReportsByTeam = async (payload: any) => {
  const response = await privateRequest.post(ENDPOINTS.REPORT_BY_TEAM, payload);
  return response.data;
};

const fetchManagers = async () => {
  const response = await privateRequest.get(ENDPOINTS.GET_MANAGERS);
  return response.data;
};

const expenseReportByTeam = async (payload: any) => {
  const response = await privateRequest.get(
    `${ENDPOINTS.REPORT_BY_TEAM}/Export`,
    {
      params: payload,
      responseType: "blob",
    },
  );
  return response;
};

const ExpenseByTeamService = {
  fetchManagers,
  fetchTeamWithGCDetail,
  fetchReportsByTeam,
  expenseReportByTeam,
};

export default ExpenseByTeamService;
